export class RealtimeEventService {
  constructor(webSocketClient, events, serviceName, logger = console) {
    if (
      !webSocketClient ||
      typeof webSocketClient.on !== 'function' ||
      typeof webSocketClient.removeListener !== 'function'
    ) {
      throw new Error('webSocketClient must implement on(type, fn) and removeListener(type, listener)');
    }

    this.webSocketClient = webSocketClient;
    this.logger = logger;
    this.EVENTS = events;

    if (typeof this.logger.debug === 'function') {
      this.logger.debug(`Initializing ${serviceName}.`);
    }
  }

  on(type, fn) {
    this.webSocketClient.on(type, fn);
  }

  removeListener(type, listener) {
    this.webSocketClient.removeListener(type, listener);
  }
}

export default RealtimeEventService;
